module.exports = __webpack_public_path__ + "img/Liefern_buchstaben_1.18547e2d.png";